<template>
  <div class="bg">
    <img class="img" src="@/assets/20231212/dy_qrcode.png" />
    <canvas id="myCanvas" width="115" height="115" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#myCanvas {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.bg {
  width: 100%;
  height: 819px;
  background: url("../../assets/20231212/bg.jpg") no-repeat;
  background-size: cover;
  position: relative;
  .img {
    position: absolute;
    top: 516px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 112px;
    height: 112px;
  }
}
</style>
